module.exports = __webpack_public_path__ + "static/img/112.9f0c041.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/112.png
// module id = 498
// module chunks = 3